<div class="progress-bar-root">
  <ng-container *ngIf="labelPosition=='start'">
    <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  </ng-container>

  <div class="progress-bar-container">
    <div
      #progressBarValue
      class="progress-bar-value"></div>
  </div>

  <ng-container *ngIf="labelPosition=='end'">
    <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #labelTemplate>
  <div
    #progressBarLabel
    class="progress-bar-label"></div>
</ng-template>
